export const moveTool = {
  install (toolbox) {
    return toolbox.extend('move', {
      action (event) {
        this.USCOPE.uScope.startCopyMoveRegion(event, 'move');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/move.js